(() => {
  const init = (root = document) => {
    const items = root.querySelectorAll('.janine-about__reveal:not([data-ja-ready])');
    if (!items.length) return;

    const revealAll = window.Shopify?.designMode
      || matchMedia('(prefers-reduced-motion: reduce)').matches
      || !('IntersectionObserver' in window);

    if (revealAll) {
      items.forEach((item) => {
        item.dataset.jaReady = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px 8% 0px' });

    items.forEach((item, index) => {
      item.dataset.jaReady = 'true';
      item.style.transitionDelay = `${Math.min(index % 3, 2) * 70}ms`;
      observer.observe(item);
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
